import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FacebookPageDTO } from '@sb-tools/typescript/models/dto/facebook-page.dto';
import { environment } from '@environment';
import { shareReplay } from 'rxjs/operators';
import { SocialMediaAccountDTO } from '@sb-tools/typescript/models/dto/social-media-account.dto';

@Injectable({ providedIn: 'root' })
export class SocialAccountsService {
    private facebookAccounts$: Observable<FacebookPageDTO[]>;
    private instagramAccounts$: Observable<SocialMediaAccountDTO[]>;
    private youtubeAccounts$: Observable<SocialMediaAccountDTO[]>;

    constructor(private httpClient: HttpClient) {}

    getFacebook(): Observable<FacebookPageDTO[]> {
        if (!this.facebookAccounts$) {
            this.facebookAccounts$ = this.httpClient
                .get<FacebookPageDTO[]>(environment.apiInboxUrl + 'Accounts/Facebook/')
                .pipe(shareReplay());
        }

        return this.facebookAccounts$;
    }

    getInstagram(): Observable<SocialMediaAccountDTO[]> {
        if (!this.instagramAccounts$) {
            this.instagramAccounts$ = this.httpClient
                .get<SocialMediaAccountDTO[]>(environment.apiInboxUrl + 'Accounts/Instagram/')
                .pipe(shareReplay());
        }

        return this.instagramAccounts$;
    }

    getYoutube(): Observable<SocialMediaAccountDTO[]> {
        if (!this.youtubeAccounts$) {
            this.youtubeAccounts$ = this.httpClient
                .get<SocialMediaAccountDTO[]>(environment.apiInboxUrl + 'Accounts/Youtube/')
                .pipe(shareReplay());
        }

        return this.youtubeAccounts$;
    }
}
